module.exports = __webpack_public_path__ + "static/media/grey.a18293f6.jpg";